<div #container
     class="container bg2 page-keyword2 {{ showDialectDetail || showWordDetail || showExampleDetail || showOtherDialect ? 'no-scroll' : '' }}"
     (scroll)="onScroll($event)">

  <app-header placeholder="이 곳의 내용, 무엇이든 검색!"
              [keyHistory]="HISTORY_KEY_SEARCH_TOTAL"
              [keyword]="keyword"
              (search)="onSearch($event)"></app-header>

  <app-left-menu></app-left-menu>


  <section class="total-list {{ showOtherDialect ? 'overlay' : '' }}">

    <div class="inner wrap {{ showWordDetail || showExampleDetail || showDialectDetail ? 'detail-open' : '' }}">

      <div class="reload-icon" *ngIf="totalSearch$">
        <!-- button (click)="onClickReload()"><img #reload src="assets/img/loading_icon.gif"></button -->
        <img #reload src="assets/img/loading_icon.gif">
      </div>

      <div class="total-list-group"
           *ngIf="!totalSearch$">

        <div class="screen-box total-screen-word">

          <div class="tit-box">단어 검색 결과</div>
          <div class="list-box">

            <article class="keyword-item-list">

              <div *ngIf="!listWord || listWord.length === 0"
                   class="keyword-item-box">
                <div class="keyword-top-box">
                  단어가 없습니다.
                </div>
              </div>

              <app-word-item *ngFor="let word of listWord; let idx = index"
                             [word]="word"
                             [select]="showWordDetail && curDetail.id === word.id"
                             class="keyword-item-box"
                             id="{{ wordSelectId(word) }}"
                             (click)="OpenWordDetail($event, word)"
                             (openWordHelp)="OpenWordHelp()"></app-word-item>

              <a class="keyword-item-box"
                 *ngIf="listWord && listWord.length > 0 && countWord > listWord.length"
                 [routerLink]="['/word']" [queryParams]="{ keyword: keyword }">
                <div class="keyword-bottom-box">
                  <div class="txt-box">더 보기</div>
                </div>
              </a>

            </article>


          </div>

        </div>

        <div class="screen-box total-screen-example">

          <div class="tit-box">문장 듣기 검색 결과</div>
          <div class="list-box">

            <article class="keyword-item-list">

              <div *ngIf="!listExample || listExample.length === 0"
                   class="keyword-item-box">
                <div class="keyword-top-box">
                  문장이 없습니다.
                </div>
              </div>

              <app-example-list-item *ngFor="let example of listExample; let idx = index"
                                     [example]="example"
                                     [select]="showExampleDetail && curDetail?.id === example.id"
                                     class="keyword-item-box"
                                     id="{{ totalExampleSelectId(example) }}"
                                     attr.data-index="{{idx}}"
                                     (click)="OpenExampleDetail($event, example)"></app-example-list-item>

              <a class="keyword-item-box"
                 *ngIf="listExample && listExample.length > 0 && countExample > listExample.length"
                 [routerLink]="['/example']" [queryParams]="{ keyword: keyword, l: 's' }">
                <div class="keyword-bottom-box">
                  <div class="txt-box">더 보기</div>
                </div>
              </a>

            </article>

          </div>

        </div>

        <div class="screen-box total-screen-saseung">

          <div class="tit-box">사 성 옥편 검색 결과</div>
          <div class="list-box">
            <ul class="our-saseung-list"
                *ngIf="!listSaseung || listSaseung.length === 0">
              <li class="our-saseung-box">
                <div class="item-wrap">
                  문자가 없습니다.
                </div>
              </li>
            </ul>

            <ul class="our-saseung-list"
                *ngIf="listSaseung && listSaseung.length > 0">

              <li class="our-saseung-box"
                  *ngFor="let saseung of listSaseung"
                  id="{{ saseungSelectId(saseung) }}"
                  [class.on]="IsSaseungSelected(saseung)"
                  (click)="OpenSaseung($event, saseung)">
                <app-saseung3-item [saseung3]="saseung"
                                   [showHangul]="true"
                                   [showBookmark]="IsSaseungSelected(saseung)"
                                   (changeBookmark)="OnSaseungBookmarkChange(saseung, $event)"></app-saseung3-item>
              </li>

              <li class="our-saseung-box"
                  *ngIf="listSaseung && listSaseung.length > 0 && countSaseung > listSaseung.length">
                <a class="item-wrap"
                   [routerLink]="['/saseung']" [queryParams]="{ keyword: keyword, l: 's' }">더 보기</a>
              </li>

            </ul>

          </div>

        </div>

        <div class="screen-box total-screen-dialect">

          <div class="tit-box">모두 우리말 검색 결과</div>
          <div class="list-box">
            <ul class="our-word-list"
                *ngIf="!listDialect || listDialect.length === 0">
              <li class="our-word-box">
                <div class="item-wrap">
                  우리말이 없습니다.
                </div>
              </li>
            </ul>

            <ul class="our-word-list"
                *ngIf="listDialect && listDialect.length > 0">

              <app-dialect-item class="our-word-box"
                                *ngFor="let dialect of listDialect"
                                id="{{ dialectSelectId(dialect) }}"
                                [dialect]="dialect"
                                [select]="showDialectDetail && curDetail?.id === dialect.id"
                                (click)="OpenDialectDetail($event, dialect)">
              </app-dialect-item>

              <li class="our-word-box"
                  *ngIf="listDialect && listDialect.length > 0 && countDialect > listDialect.length">
                <a class="item-wrap"
                   [routerLink]="['/dialect']" [queryParams]="{ keyword: keyword }">더 보기</a>
              </li>


            </ul>

          </div>

        </div>

        <div class="screen-box total-screen-proverb">

          <div class="tit-box">속담 검색 결과</div>
          <div class="list-box">

            <div *ngIf="!listProverb || listProverb.length === 0"
                 class="keyword-item-box">
              <div class="keyword-top-box">
                속담이 없습니다.
              </div>
            </div>

            <app-proverb-item class="keyword-item-box proverb"
                              *ngFor="let proverb of listProverb; let idx = index"
                              id="{{ proverbSelectedId(proverb) }}"
                              [proverb]="proverb"
                              [isSelected]="IsProverbSelected(proverb)"
                              (click)="Unfold($event, proverb)"></app-proverb-item>


            <a class="keyword-item-box"
               *ngIf="listProverb && listProverb.length > 0 && countProverb > listProverb.length"
               [routerLink]="['/proverb']" [queryParams]="{ keyword: keyword }">
              <div class="keyword-proverb-box">
                <div class="keyword-bottom-box">
                  <div class="txt-box">더 보기</div>
                </div>
              </div>
            </a>


          </div>

        </div>

        <div class="screen-box total-screen-video">

          <div class="tit-box">동영상 검색 결과</div>
          <div class="list-box">

            <ul>
              <li *ngIf="listVideo === null || listVideo.length === 0">
                <div class="item-box">
                  영상이 없습니다.
                </div>
              </li>
              <li *ngFor="let video of listVideo">
                <app-video-item [video]="video"
                                [sendingBookmark]="sendingBookmark"
                                (toggleBookmark)="VideoToggleBookmark($event)"></app-video-item>
              </li>

              <li *ngIf="listVideo && listVideo.length > 0 && countVideo > listVideo.length">
                <a class="item-box"
                   [routerLink]="['/movie-search']" [queryParams]="{ keyword: keyword, l: 's' }">
                  <div class="keyword-bottom-box">
                    <div class="txt-box">더 보기</div>
                  </div>
                </a>
              </li>
            </ul>

          </div>

        </div>

      </div>

    </div>
  </section>


  <!-- 단어 상세 팝업창 -->
  <app-word-detail *ngIf="showWordDetail" [@wordDetailInOut]
                   class="word-detail keyword-detail"
                   [word_id]="curDetail.id"
                   [height]="detailHeight"
                   (closeDetail)="CloseWordDetail($event)"
                   (openMap)="OpenDialectMapWord($event)"></app-word-detail>


  <app-dialect-detail *ngIf="showDialectDetail" [@wordDetailInOut]
                      class="our-word-detail"
                      [dialect_id]="curDetail.id"
                      [height]="detailHeight"
                      (openMap)="OpenDialectMapDialect($event)"
                      (closeDetail)="CloseDialectDetail($event)"></app-dialect-detail>

  <app-example-detail *ngIf="showExampleDetail" [@wordDetailInOut]
                      class="word-detail keyword-detail example-detail"
                      [example_id]="curDetail.id"
                      [height]="detailHeight"
                      [showHelpButton]="true"
                      (openExampleHelp)="OpenExampleHelp()"
                      (closeDetail)="CloseExampleDetail()"></app-example-detail>

  <app-dialect-map *ngIf="showOtherDialect" [@wordDetailInOut]
                   class="dialect-map search-detail type-region no-jaso-idx"
                   [word]="mapWord"
                   [dialects]="mapDialects"
                   (closePopup)="CloseDialectMap()"></app-dialect-map>


  <app-footer></app-footer>

  <!-- help popup -->
  <article class="popup popup-help"
           *ngIf="lm.showHelp">
    <app-word-help (closePopup)="CloseWordHelp()"></app-word-help>
  </article>

  <article class="popup popup-help"
           *ngIf="lm.showPitchHelp">
    <app-pitch-help-popup (closePopup)="ClosePitchHelp()"></app-pitch-help-popup>
  </article>

  <article class="popup popup-help"
           *ngIf="lm.showExampleHelp">
    <app-example-help (closePopup)="CloseExampleHelp()"></app-example-help>
  </article>

</div>


<app-common-popups></app-common-popups>
